import $ from 'jquery';

import { default as DefaultMap, handleWebGlError } from 'JIX/map/DefaultMap.js';
import ClusteredJobs from 'JIX/map/ClusteredJobs.js';

const stash = window.Stash['widgets/map'];

$(() => {
    stash.forEach(({ id, stash }) => {
        const options = {
            container: id,
            style: stash.style,
        };
        if (stash.zoom !== undefined) {
            options.zoom = stash.zoom;
        }
        if (stash.center !== undefined) {
            options.center = stash.center;
        }
        let map;
        try {
            map = new DefaultMap(options);
        } catch (error) {
            handleWebGlError(error, id);
            return;
        }
        const fitBounds = !stash.center;
        new ClusteredJobs({}).addTo(map).setData(stash.map_data, fitBounds);
    });
});
